import * as React from 'react';

const InfoIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<circle cx='10' cy='10' r='9' stroke='#2563eb' strokeWidth='2' />
			<path d='M10 6V10M10 14H10.01' stroke='#2563eb' strokeWidth='2' strokeLinecap='round' />
		</svg>
	);
};

export default InfoIcon;
